var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherOvercast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31 23.94637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-758 -24.24899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779.90244,43.19536A4.0423,4.0423,0,0,0,784,39.21069a3.99319,3.99319,0,0,0-2.609-3.7123,3.17829,3.17829,0,0,0,.048-.52142,3.28439,3.28439,0,0,0-3.32926-3.23755,3.38507,3.38507,0,0,0-1.47256.33465,5.68836,5.68836,0,0,0-10.444,1.52538A4.96693,4.96693,0,0,0,763,38.21452a5.04182,5.04182,0,0,0,5.122,4.98084Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-758 -24.24899)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 177,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather_overcast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23.94637,
    style: {
      fill: "#989798",
      opacity: 0.980000019073486
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherOvercast);
export default __webpack_public_path__ + "static/media/weather_overcast.d2f64e5b871e982f0e713840fbf0d90a.svg";
export { ForwardRef as ReactComponent };